import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useShiftQuery as useShiftQueryType } from "@/modules/productivity-cockpit/services/__generated__/useShiftQuery.graphql"

const shiftQuery = graphql`
  query useShiftQuery {
    todayShiftOverview {
      shiftEnd
      shiftStart
      shiftInformation
      shiftType
    }
  }
`

const useShiftQuery = () =>
  useLazyLoadQuery<useShiftQueryType>(
    shiftQuery,
    {},
    {
      fetchPolicy: "network-only",
    },
  )

export { useShiftQuery }
